import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TopViolatorsList = ({ violators }) => {
  const getRiskBadge = (riskLevel) => {
    const styles = {
      critical: 'bg-error/10 text-error border-error',
      high: 'bg-warning/10 text-warning border-warning',
      medium: 'bg-accent/10 text-accent border-accent'
    };
    return styles?.[riskLevel] || styles?.medium;
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 elevation-sm">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Top Violators
        </h2>
        <Link 
          to="/all-violations"
          className="text-sm font-caption text-primary hover:text-primary/80 transition-smooth flex items-center gap-1"
        >
          View All
          <Icon name="ArrowRight" size={16} />
        </Link>
      </div>
      <div className="space-y-3">
        {violators?.map((violator, index) => (
          <div 
            key={violator?.id}
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-muted transition-smooth cursor-pointer"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-muted text-foreground font-semibold text-sm flex-shrink-0">
              {index + 1}
            </div>
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden flex-shrink-0">
              <Image 
                src={violator?.avatar}
                alt={violator?.avatarAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm md:text-base font-caption font-medium text-foreground truncate">
                {violator?.name}
              </p>
              <p className="text-xs md:text-sm font-caption text-muted-foreground truncate">
                {violator?.department}
              </p>
            </div>
            <div className="flex flex-col items-end gap-1 flex-shrink-0">
              <span className="text-sm md:text-base font-semibold text-foreground data-text whitespace-nowrap">
                {violator?.points} pts
              </span>
              <span className={`text-xs font-caption px-2 py-0.5 rounded-full border ${getRiskBadge(violator?.riskLevel)}`}>
                {violator?.riskLevel}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopViolatorsList;